/**
 * Mobile hamburger menu (sections/header.liquid). The button toggles
 * html.menu-open, which shows the full-screen .header__menus overlay
 * and morphs the hamburger into an X — all presentation lives in the
 * header's CSS. Closes on link tap and Escape. Re-binds after theme
 * editor section re-renders (shopify:section:load replaces the DOM).
 */
const html = document.documentElement;

function setOpen(open) {
  html.classList.toggle('menu-open', open);
  const btn = document.querySelector('.header__menu-toggle');
  if (btn) btn.setAttribute('aria-expanded', String(open));
  // Pause the Lenis inertia scroll while the overlay locks the page.
  if (window.__lenis) window.__lenis[open ? 'stop' : 'start']();
  if (!open) collapseAll();
}

/* Mobile: parent rows expand their children inline (+ / −). */
function collapseAll() {
  for (const item of document.querySelectorAll('.header__nav-item.is-expanded')) setExpanded(item, false);
}
function setExpanded(item, expanded) {
  item.classList.toggle('is-expanded', expanded);
  const btn = item.querySelector('.header__nav-expand');
  if (btn) btn.setAttribute('aria-expanded', String(expanded));
}

function bind() {
  const btn = document.querySelector('.header__menu-toggle');
  const menus = document.getElementById('header-menus');
  if (!btn || !menus || btn.dataset.bound) return;
  btn.dataset.bound = 'true';

  btn.addEventListener('click', () => setOpen(!html.classList.contains('menu-open')));
  menus.addEventListener('click', (event) => {
    const expand = event.target.closest('[data-menu-expand]');
    if (expand && html.classList.contains('menu-open')) {
      const item = expand.closest('.header__nav-item');
      if (item) setExpanded(item, !item.classList.contains('is-expanded'));
      return;
    }
    if (event.target.closest('a')) setOpen(false);
  });
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setOpen(false);
});
document.addEventListener('shopify:section:load', bind);
bind();
